import './stock-bound-info.scss';

import { Modal } from 'antd';
import React from 'react';

import { Button } from '@/components/Shared/ui';

interface IProps {
  name: string;
  conditions: Array<Array<{ name: string; value: string }>>;
  isOpened: boolean;
  onClose: (isOpened: boolean) => void;
}

const StockBoundInfo: React.FC<IProps> = ({
  name,
  conditions,
  isOpened,
  onClose
}) => {
  function handleClose() {
    onClose(false);
  }

  return (
    <Modal
      centered
      mask={{ closable: true }}
      className="stock-bound-info"
      title="Условия акции"
      open={isOpened}
      onCancel={handleClose}
      footer={null}
    >
      <p className="stock-bound-info__subtitle">{name}</p>

      <div className="stock-bound-info__content">
        {conditions.map((condition, index, arr) => (
          <div className="stock-bound-info__condition" key={index}>
            <p className="stock-bound-info__condition-title">
              {index !== arr.length - 1 ? `Условие ${index + 1}` : 'Общие'}
            </p>
            {condition.map((item) => (
              <div key={item.name} className="stock-bound-info__info">
                <span className="stock-bound-info__name">{item.name}</span>
                <b className="stock-bound-info__value">{item.value}</b>
              </div>
            ))}
          </div>
        ))}
      </div>

      <Button
        fullWidth
        onClick={handleClose}
        className="stock-bound-info__close"
      >
        Закрыть
      </Button>
    </Modal>
  );
};

export default StockBoundInfo;
